'use client'

import Terms from '@/app/terms/_components/Terms'
import { useScrollTracking } from '@/hooks/useScrollTracking'

const TermsPage = () => {
  useScrollTracking()
  
  return <Terms />
}

export default TermsPage
